$(document).on('click', '.js-application-v2 .js-modal-open', function(e){
  e.preventDefault();
  var $modalWrapper = $('.js-modal-wrapper');

  // Insert modal wrapper if it doesn't exist yet.
  if ( $modalWrapper.length == 0 ) {
    $('<div class="js-modal-wrapper"></div>")').appendTo('body');
    $modalWrapper = $('.js-modal-wrapper');
  }

  var url = $(this).data('url');
  $modalWrapper.load(url, function() {
    var $modal = $modalWrapper.find(".js-modal");
    $modal.modal('show');

    $modal.one('hidden.bs.modal', function () {
      $modalWrapper.empty();
    });
    $modal.find('.js-focus-eol').focus();

    $(document).trigger("PartialLoaded");
  });

});

$(document).on('click', '.js-sign-in-modal-open', function() {
  setTimeout( function() {
    $(".js-sign-in-email").attr("type", "text");
    $(".js-sign-in-password").hide().attr("type", "text");
  }, 1000);
});

$(document).on('click', '.js-sign-in-modal-close', function() {
  $(".js-sign-in-email").attr("type", "email");
  $(".js-sign-in-password").show().attr("type", "password");
});

$(document).on('click', '.js-modal-close', function() {
  $('.modal.in').modal('hide');
});
